import ImgTag from "@/components/Helpers/ImgTag";
// import MispayModal from "@/components/modals/MispayModal";
import { useState } from "react";
import MispayModal from "./MispayModal";

const MisPay = ({ locale, amount }) => {
  const [show, setShow] = useState(false);
  return (
    amount >= 50 &&
    amount <= 4000 && (
      <>
        <div
          onClick={() => setShow(true)}
          className="flex items-center gap-3 p-2 px-1 mt-2 border rounded-md"
        >
          <ImgTag
            width={100}
            height={28}
            // className={`h-8 object-cover`}
            className="h-[35px] w-auto object-contain"
            src={`/imgs/mispay/mispay-widget.svg`}
            alt="Tamara"
          />
          <span>
            {locale === "ar" ? (
              <>
                4 دفعات بقيمة{" "}
                <span className="font-bold">
                  {(amount / 4)?.toFixed(2)} ر.س .
                </span>
                شهرياً، بدون رسوم تأخير، متوافق مع أحكام الشريعة الإسلامية.
              </>
            ) : (
              <>
                4 payments of
                <span className="font-bold">
                  {" "}
                  SAR {(amount / 4)?.toFixed(2)}
                </span>
                /mo, No late fees, Sharia compliant.
              </>
            )}
            <span className="text-sm font-bold underline cursor-pointer max-[991px]:text-base">
              {locale === "ar" ? " اعرف أكثر" : " Learn more"}
            </span>
          </span>
        </div>
        <MispayModal {...{ amount, locale, show, setShow }} />
      </>
    )
  );
};

export default MisPay;
